import { NgModule } from '@angular/core';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressButtonsModule } from 'mat-progress-buttons';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LayoutModule } from '@angular/cdk/layout';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CdkTreeModule } from '@angular/cdk/tree';



@NgModule({
    imports: [
        MatSidenavModule,
        MatToolbarModule,
        MatIconModule,
        MatListModule,
        MatChipsModule,
        MatGridListModule,
        MatMenuModule,
        MatButtonModule,
        MatTableModule,
        MatSelectModule,
        MatInputModule,
        MatPaginatorModule,
        MatCheckboxModule,
        MatRadioModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatCardModule,
        MatTabsModule,
        MatStepperModule,
        MatProgressBarModule,
        MatExpansionModule,
        MatProgressButtonsModule,
        MatSortModule,
        MatTreeModule,
        MatDividerModule,
        MatTooltipModule,
        DragDropModule,
        MatAutocompleteModule,
        LayoutModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatSnackBarModule,
        MatTreeModule,
        CdkTreeModule,
        MatButtonToggleModule,
        FlexLayoutModule  ],
    exports: [
        MatSidenavModule,
        MatToolbarModule,
        MatIconModule,
        MatListModule,
        MatChipsModule,
        MatGridListModule,
        MatMenuModule,
        FlexLayoutModule,
        MatButtonModule,
        MatTableModule,
        MatSelectModule,
        MatInputModule,
        MatPaginatorModule,
        MatCheckboxModule,
        MatRadioModule,
        MatProgressSpinnerModule,
        MatCardModule,
        MatTabsModule,
        MatStepperModule,
        MatProgressBarModule,
        MatExpansionModule,
        MatProgressButtonsModule,
        MatSortModule,
        MatTreeModule,
        MatDividerModule,
        MatTooltipModule,
        DragDropModule,
        MatAutocompleteModule,
        LayoutModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatSnackBarModule,
        MatButtonToggleModule
    ]
})
export class MaterialModule { }
